import { ActionIcon, Avatar } from '@mantine/core';
import React from 'react'
import { useParams } from 'react-router';
import { FaceId } from 'tabler-icons-react';
import useBoardHook from '../../utils/useBoardHook';
import useCheckAdminBoard from '../../utils/useCheckAdminBoard'
import useGetAdminDataBoard from '../../utils/useGetAdminDataBoard';

const BoardGuestActions = ({onFaceIdClick,faceIdLoading,isVisibleMainPhotographLogo,showOnlyMatching,hasSelfie}) => {
    let { subdomain } = useParams();

    const admin = useCheckAdminBoard(subdomain);
    const getDocumentBoard = useBoardHook(subdomain);
    const { getAdmin } = useGetAdminDataBoard(subdomain);

    const canGuestView = admin || !!getDocumentBoard?.data?.published

    const adminAvatar = getAdmin?.avatar;
    const adminFirstName = getAdmin?.firstName;
    const adminLastName = getAdmin?.lastName;
    const adminInitials = adminFirstName?.split('')[0]+adminLastName?.split('')[0];

    const stylesIconInactive = {
        root: {
            color:'#7a7a7a',
            backgroundColor: showOnlyMatching ? '#504f4fc4' : '#000000bd',
            width: '50px',
            height:'50px',
            borderRadius:'50%',
            padding:'12px'
        }
    }

    return (
        <>
            {/* {(canGuestView && !admin && hasSelfie) &&
            <div onClick={() => onFaceIdClick()} className="fixed shadow-md rounded-full z-40 right-3 bottom-3">
                <ActionIcon 
                    styles={stylesIconInactive}
                    loading={faceIdLoading} 
                    color='dark'
                    size="lg" 
                    variant="transparent"
                >
                    <FaceId color="white"   />
                </ActionIcon>
            </div>} */}

            {/* {(canGuestView && !admin && hasSelfie) &&
            <a href={!!getAdmin?.data?.website.length && getAdmin?.data?.website} target="_blank" rel="noreferrer" className={`cursor-pointer w-[50px] h-[50px] rounded-full fixed ${!isVisibleMainPhotographLogo ? 'block' : 'hidden'} bottom-3 left-3 z-40`}>
                {adminAvatar 
                ? 
                    <Avatar className="mb-2" radius="xl" style={{width:'50px',height:'50px'}} src={`https://picboard.imgix.net/${adminAvatar}`} alt="AvatarAdmin" /> 
                : 
                    (!adminAvatar && adminFirstName && adminLastName 
                    ?
                        <Avatar className="mb-2 uppercase" color="blue" radius="xl" style={{width:'50px',height:'50px'}} src={null} alt="AvatarUser">{adminInitials}</Avatar>
                    :
                        <Avatar className="mb-2 uppercase" color="blue" radius="xl" style={{width:'50px',height:'50px'}} src={null} alt="AvatarUser" />
                    )
                }
            </a>} */}
        </>
    )
}

export default BoardGuestActions